// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__2aBFh","tab":"Tabs_tab__2OnI_","tabActive":"Tabs_tabActive__2P92k"};